<div class="c__wrapper">
  <div class="c__wrapper-content-info">
    <div class="c__content">
      <div class="c__index-wrapper">
        <sd-icon [brand]="brand" name="icon-reparability" [size]="iconSize.medium" />
        <p class="c__index brand--h2">
          <span class="c__actual-index">{{ stringValue }}</span>
          <span class="c__max-index">/10</span>
        </p>
      </div>
      <p class="c__title {{isMobile$ && !isSmall ? 'brand--h5 is-bold' : 'is-bold'}}">
        {{ "product.reparability.label" | translate }}
      </p>
    </div>

    @if (reparabilityData?.link?.url && showInfo) {
      <div class="c__infos">
        <sd-html #reparabilityLink innerClass="c__reparability-link"
          [html]="'product.reparability.info' | translate : {calculateLink: reparabilityData?.calculateLink?.url}"
        />
        @if (!isDevice$) {
          <sd-link class="c__more-link" [link]="reparabilityData?.link" (clicked)="onRepairabilityInfoClick()">
            {{ "actions.learnMore" | translate }}
          </sd-link>
        }
        @if (isDevice$ && showInfo) {
          <sd-link class="c__more-link" [link]="reparabilityData?.link" (clicked)="onRepairabilityInfoClick()">
            {{ "actions.learnMore" | translate }}
          </sd-link>
        }
      </div>
    }
  </div>
</div>
